import Vue from 'vue'
import Vuex from 'vuex'
import configModule, { ConfigState } from './modules/config'
import raceModule, { RaceState } from './modules/race'

Vue.use(Vuex)

export type RootState = {
  config: ConfigState,
  race: RaceState
}

export default new Vuex.Store({
  actions: {
    async init (context): Promise<void> {
      /* get config before doing anything */
      try {
        await context.dispatch('config/init')
        await context.dispatch('race/fetchRhumbline', { raceId: this.state.config.YACHT_TRACKER_RACE_ID })
        await context.dispatch('race/fetchRaceContext', {
          raceId: this.state.config.YACHT_TRACKER_RACE_ID,
          raceTime: '',
          raceTimeMin: this.state.config.YACHT_TRACKER_RACETIME_MIN,
          raceTimeMax: this.state.config.YACHT_TRACKER_RACETIME_MAX
        })
      } catch (e) {
        console.warn('error', e)
      }
    },
    reset (context): void {
      context.dispatch('race/reset')
      context.dispatch('config/reset')
    }
  },
  modules: {
    config: configModule,
    race: raceModule
  }
})
